<div nz-dropdown nzTrigger="click" (click)="onClickIcon()" class="export-icon icon-button-24" [nzDropdownMenu]="exportMenu"></div>

<nz-dropdown-menu #exportMenu>
  <ul nz-menu class="export-menu">
    <li nz-menu-item *ngFor="let item of dropDownMenu" (click)="download(item.label, item.type)">{{ item.label }}</li>
  </ul>
</nz-dropdown-menu>
